import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/ruby';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.ruby.run-server.body',
        defaultMessage:
          'Run your Ruby server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant}) => `require 'sinatra'
{+setup}
require 'stripe'
${comment && comment(merchant, '#')}
Stripe.api_key = '${keys.secret}'
{/setup}

set :static, true
set :port, 4242

# Securely calculate the order amount
def calculate_order_amount(_items)
  # Replace this constant with a calculation of the order's amount
  1400
end

{?save-card charge}
def charge_customer(customerId)
  # Lookup all payment methods for customer
  payment_methods = Stripe::PaymentMethod.list(
    customer: customerId,
    type: 'card'
  )

  # Charge the customer and payment method immediately
  payment_intent = Stripe::PaymentIntent.create(
    amount: 1099,
    currency: 'usd',
    customer: customerId,
    payment_method: payment_methods.data[0]['id'],
    off_session: true,
    confirm: true
  )

  if payment_intent['status'] == 'succeeded'
    puts '✅ Successfully charged card off session'
  end
end

{/charge}
# An endpoint to start the payment process
post '/create-payment-intent' do
  content_type 'application/json'
  data = JSON.parse(request.body.read)
  {?save-card customer}
  # Alternatively, set up a webhook to listen for the payment_intent.succeeded event
  # and attach the PaymentMethod to a new Customer
  customer = Stripe::Customer.create
  {/customer}

  {+create}
  # Create a PaymentIntent with amount and currency
  {span response create}payment_intent{/span} = Stripe::PaymentIntent.create(
    {?save-card pass-customer}
    customer: customer['id'],
    setup_future_usage: 'off_session',
    {/pass-customer}
    amount: calculate_order_amount(data['items']),
    currency: 'usd'
  )

  {
    clientSecret: payment_intent['client_secret'],
  }.to_json
  {/create}
end
`;
